import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShift"><Path d="M13.0952 2.4722C12.5023 1.84265 11.4997 1.84259 10.9067 2.47209L2.40995 11.4927C1.50977 12.4484 2.18929 14.0144 3.50413 14.0144H5.9964V18.5052C5.9964 19.883 7.11654 21 8.49832 21H15.5037C16.8855 21 18.0056 19.883 18.0056 18.5052V14.0144H20.4959C21.8106 14.0144 22.4902 12.4485 21.5902 11.4928L13.0952 2.4722Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShift;
